var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 17.682 13.682 C 16.868 14.496 15.743 15 14.5 15 C 12.015 15 10 12.985 10 10.5 C 10 9.257 10.504 8.132 11.318 7.318 C 11.725 6.911 12.21 6.581 12.748 6.354 C 12.883 6.297 13.021 6.246 13.162 6.202",
    fill: "transparent",
    stroke: "rgb(76, 106, 112)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 17.969 12.613 C 17.949 12.815 17.918 13.014 17.878 13.209 C 17.798 13.6 17.68 13.977 17.528 14.335 C 17.225 15.053 16.786 15.7 16.243 16.243 C 15.157 17.328 13.657 18 12 18 C 8.686 18 6 15.314 6 12 C 6 8.686 8.686 6 12 6 C 12.414 6 12.819 6.042 13.209 6.122",
    fill: "transparent",
    stroke: "rgb(76, 106, 112)",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.59953ed55abc1ea1d3585389d8d649a2.svg";
export { ForwardRef as ReactComponent };